// X（旧Twitter）広告の計測タグ。広告から来た人が登録・購入したかを X に知らせ、広告の配信を「登録しそうな人」に寄せる。
// 本番（hyakki.honulabs.net）だけで読む。テストサーバー・開発では読まない。送る内容はプライバシーポリシー 4章に書く。
// イベントは X 広告のイベントマネージャーで作ったもの（ピクセル rif6p）。
const PIXEL_ID = 'rif6p';
const EVENT_SIGNUP = 'tw-rif6p-rif7r';
const EVENT_PURCHASE = 'tw-rif6p-rif9b';
const HOST = 'hyakki.honulabs.net';

type Twq = ((...args: unknown[]) => void) & { exe?: (...args: unknown[]) => void; queue: unknown[][]; version: string };
const w = window as unknown as { twq?: Twq };

const enabled = () => !import.meta.env.DEV && location.hostname === HOST;

/** 起動時に一度だけ。X の公式のベースコードと同じ動き（インラインの script を使わないためここで書く） */
export function initXPixel() {
  if (!enabled() || w.twq) return;
  const q = function (...args: unknown[]) {
    if (q.exe) q.exe(...args);
    else q.queue.push(args);
  } as Twq;
  q.version = '1.1';
  q.queue = [];
  w.twq = q;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://static.ads-twitter.com/uwt.js';
  document.head.appendChild(s);
  q('config', PIXEL_ID);
}

/** 新しくアカウントを作ったとき（ゲスト・Google とも、サーバーが created を返したときだけ） */
export function trackSignup() {
  if (enabled()) w.twq?.('event', EVENT_SIGNUP, {});
}

/** 購入が反映されたとき（注文ごとに1回。conversion_id で X 側でも重複を除く） */
export function trackPurchase(orderId: string, yen: number) {
  if (enabled()) w.twq?.('event', EVENT_PURCHASE, { value: yen, currency: 'JPY', conversion_id: orderId });
}
